import React, { memo, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface AddReportCardProps {
  showForm: boolean;
  customReportQuery: string;
  onQueryChange: (query: string) => void;
  onCancel: () => void;
  onGenerate: () => void;
  onAddClick: () => void;
}

// Memoized component to prevent unnecessary re-renders
const AddReportCard: React.FC<AddReportCardProps> = memo(({
  showForm,
  customReportQuery,
  onQueryChange,
  onCancel,
  onGenerate,
  onAddClick
}) => {
  const { t } = useTranslation(['create', 'common']);
  // Ref for the textarea to focus it when the form is shown
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  
  // Focus the textarea when the form is shown
  useEffect(() => {
    if (showForm && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [showForm]);
  
  // If the form is shown, render the form
  if (showForm) {
    return (
      <div className="analytics-card add-report-placeholder form">
        <h4>{t('analytics.custom_add')}</h4>
        <textarea
          ref={textareaRef}
          className="custom-report-input"
          placeholder={t('analytics.custom_placeholder')}
          value={customReportQuery}
          onChange={(e) => onQueryChange(e.target.value)}
          rows={4}
        />
        <div className="card-actions">
          <button
            className="cancel-button"
            onClick={onCancel}
          >
            {t('common:cancel')}
          </button>
          <button
            className="generate-button"
            onClick={onGenerate}
            disabled={!customReportQuery.trim()}
          >
            {t('analytics.generate')}
          </button>
        </div>
      </div>
    );
  }
  
  // If the form is not shown, render the "Add Report" button
  return (
    <div 
      className="analytics-card add-report-placeholder"
      onClick={onAddClick}
    >
      <div className="add-report-content">
        <div className="add-icon">+</div>
        <h4>{t('analytics.custom_add')}</h4>
        <p>{t('analytics.custom_placeholder')}</p>
      </div>
    </div>
  );
});

export default AddReportCard;
